import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { FieldConfig } from '../../models/field-configs/field-config.interface';
import { AbstractField } from '../../models/field-configs/abstract-field';

@Component({
  selector: 'form-input',
  styleUrls: ['form-input-checkbox.component.scss'],
  templateUrl: 'form-input-checkbox.component.html',
})
export class FormInputCheckboxComponent extends AbstractField implements OnInit {
  config: FieldConfig;
  group: UntypedFormGroup;
  withPadding = true;

  fieldControl: AbstractControl;

  ngOnInit(): void {
    this.fieldControl = this.getControl();

    if (this.config.hasOwnProperty('withPadding')) {
      this.withPadding = this.config['withPadding'];
    }
  }
}
